module.exports = __webpack_public_path__ + "static/favicon-057cb726f234c0b0763fc615c0d4daa0.ico";